var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.164 4.396c.75 0 1.688-.521 2.247-1.217.506-.63.875-1.511.875-2.392 0-.12-.01-.239-.031-.337-.834.033-1.836.576-2.437 1.305-.474.554-.907 1.424-.907 2.315 0 .13.021.261.032.305.053.01.137.021.221.021zM6.528 17.55c1.023 0 1.476-.706 2.752-.706 1.298 0 1.582.684 2.721.684 1.118 0 1.867-1.065 2.574-2.108.79-1.196 1.118-2.37 1.139-2.425-.074-.021-2.215-.924-2.215-3.457 0-2.196 1.688-3.185 1.782-3.261-1.117-1.652-2.816-1.696-3.28-1.696-1.255 0-2.278.783-2.921.783-.696 0-1.614-.74-2.7-.74-2.067 0-4.166 1.762-4.166 5.088 0 2.066.78 4.25 1.74 5.664.823 1.196 1.54 2.174 2.574 2.174z",
    fill: "#424242"
  })));
}
export default SvgAppleinline;